import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
    selector: 'app-nCash-popup',
    templateUrl: './nCash-popup.component.html',
    styleUrls: ['./nCash-popup.component.scss']
})
export class NCashPopupComponent {
    private readonly matDialogRef: MatDialogRef<NCashPopupComponent>;
    constructor(
        matDialogRef: MatDialogRef<NCashPopupComponent>
    ) {
        this.matDialogRef = matDialogRef;
    }
    onClickClose() {
        return this.matDialogRef.close();
    }
}